module.exports = __webpack_public_path__ + "img/projectList_bg14.2092c979.png";